module.exports = new __parcel__URL__("light-bulb.9c6e1543.svg").toString();